import PropTypes from 'prop-types';
import React from 'react';

import $ from 'jquery';

const Header = require('./header');
const ItemsCollection = require('./items_collection');
const Footer = require('./footer');

const cx = require('classnames');

class ItemsSelector extends React.Component {

  static propTypes = {
    className: PropTypes.string,                                   // class name applied to the container div
    hiddenFieldId: PropTypes.string,                               // id attached to the hidden input
    hiddenFieldName: PropTypes.string,                             // name attached to the hidden input
    items: PropTypes.arrayOf(PropTypes.object).isRequired,         // A collection of items to display.  Minimum required field is `name`
    onClose: PropTypes.func,                                       // a function that will be invoked when the modal is closed
    onToggle: PropTypes.func,                                      // a function that will be invoked when an item is toggled
    preselectedItemIds: PropTypes.oneOfType([                      // A collection of preselected item ids
      PropTypes.string,
      PropTypes.array,
    ]),
    presentSelectorClickTargetId: PropTypes.string,                // We'll attach a listener to the supplied id that toggles visibility
    showHeader: PropTypes.bool,                                    // boolean to determine header visibility
    showFooter: PropTypes.bool,                                    // boolean to determine footer visibility
    submitTo: PropTypes.func,                                      // i honestly have no idea what this is.
    toggleAllclickTargetId: PropTypes.string,                      // handle for the toggle all switch, external to the component.
    showTooltipDescriptions: PropTypes.bool                        // boolean to determine display of description tooltip next to each item
  };

  static defaultProps = {
    className: null,
    hiddenFieldName: null,
    hiddenFieldId: null,
    onClose: new Function(),
    onToggle: new Function(),
    preselectedItemIds: [],
    presentSelectorClickTargetId: null,
    showHeader: false,
    showFooter: false,
    submitTo: new Function(),
    toggleAllclickTargetId: null,
    showTooltipDescriptions: false
  };

  constructor (props) {
    super(props);
    this.state = {
      items: [],
      visible: (!props.presentSelectorClickTargetId),
      hasGroupedItems: false,
      showTooltipDescriptions: false
    };
  }

  componentDidUpdate () {
    this._dispatchEvent();
  }

  componentDidMount () {
    $(document.body).on('items-selector-choose', this.selectItems);
    this.setState({ items: this.structureItemsForDisplay(this.props.items) });
    if (this.props.toggleAllclickTargetId) {
      document.getElementById(this.props.toggleAllclickTargetId).addEventListener('click', this.toggleAllItems.bind(this));
    }
    if (this.props.presentSelectorClickTargetId) {
      document.getElementById(this.props.presentSelectorClickTargetId).addEventListener('click', this.togglePresentSelector.bind(this));
    }
  }

  componentWillUnmount () {
    $(document.body).off('items-selector-choose', this.selectItems);
    if (this.props.toggleAllclickTargetId) {
      document.getElementById(this.props.toggleAllclickTargetId).removeEventListener('click', this.toggleAllItems.bind(this));
    }
    if (this.props.presentSelectorClickTargetId) {
      document.getElementById(this.props.presentSelectorClickTargetId).removeEventListener('click', this.togglePresentSelector.bind(this));
    }
  }

  selectItems = (el, opts) => {

    this.state.items.forEach((item) => {
      if (item.group) {
        item.showChildren = false;
        item.children.forEach((child) => {
          child.selected = opts.items.indexOf(child.id) !== -1;
          item.showChildren = item.showChildren || child.selected;
        });
      } else {
        item.selected = opts.items.indexOf(item.id) !== -1;
      }
    });

    this.setState(this.state);
  };

  /**
   * Since our items come in as a flat list, we need to build the nested structure for grouped hierarchies
   * @returns {Array}
   */
  structureItemsForDisplay (flatItems) {
    const items = [];

    let hasGroupedItems = false;

    flatItems.forEach((groupedItem) => {
      groupedItem.children = flatItems.filter(item => (item.group_id === groupedItem.id));
      let childSelected = false;

      groupedItem.children.forEach((child) => {
        hasGroupedItems = true;
        child.selected = (this.props.preselectedItemIds.indexOf(child.id) > -1);
        if (child.selected) {
          childSelected = true;
        }
      }, this);

      // We want to ensure group parents are not being selected.
      if (groupedItem.children.length <= 0) {
        groupedItem.selected = (this.props.preselectedItemIds.indexOf(groupedItem.id) > -1);
      }

      groupedItem.showChildren = childSelected;
      if (!groupedItem.group_id) {
        items.push(groupedItem);
      }
    }, this);

    this.setState({ hasGroupedItems: hasGroupedItems });

    return items;
  }

  /**
   * Toggle one or many items' selected state.  If forceValue is passed, set all items to that value.
   * @param items
   * @param {boolean} forceValue
   */
  toggleItems = (items, forceValue) => {
    if (!items || items.length === 0) return;
    if (forceValue !== true && forceValue !== false) forceValue = null;
    items = Array.isArray(items) ? items : new Array(items);

    items.forEach((item) => {
      let index;
      if (item.group_id) {
        // this is a child component, so we need to find the group and target its items
        index = this.state.items.findIndex(i => i.id === item.group_id);
        for (const child of this.state.items[index].children) {
          if (child.id === item.id) {
            child.selected = forceValue || !child.selected;
            break;
          }
        }
      } else {
        // standard component
        index = this.state.items.findIndex(i => i.id === item.id);
        this.state.items[index].selected = !this.state.items[index].selected;
      }
      this.setState(this.state, this.props.onToggle.bind(undefined, this.state.items));
      this._dispatchEvent();
    }, this);
  }

  /**
   * Toggle all items' selected state
   */
  toggleAllItems () {
    let groupedItemCount = 0;
    let selectedCount = 0;

    this.state.items.forEach((groupedItem) => {
      if (groupedItem.children.length > 0) {
        groupedItem.children.forEach((child) => {
          groupedItemCount++;
          if (child.selected) selectedCount++;
        });
      } else {
        groupedItemCount++;
        if (groupedItem.selected) selectedCount++;
      }
    });

    const newValue = (selectedCount !== groupedItemCount);
    this.state.items.forEach((groupedItem) => {
      if (groupedItem.children.length > 0) {
        groupedItem.children.forEach((child) => {
          child.selected = newValue;
        });
      } else {
        groupedItem.selected = newValue;
      }
    });

    this.setState(this.state, this.props.onToggle.bind(undefined, this.state.items));
    this._dispatchEvent();
  }

  clearAllItems = () => {
    this.state.items.forEach((item) => {
      if (item.children.length > 0) {
        item.children.forEach((child) => {
          child.selected = false;
        });
      } else {
        item.selected = false;
      }
    });

    this.setState(this.state, this.props.onToggle.bind(undefined, this.state.items));
  }

  /**
   * Currently selected items.
   * @returns {Array}
   */
  selectedItems () {
    const selectedItems = [];
    this.state.items.forEach((item) => {
      if (item.children.length > 0) {
        // It's a group!
        item.children.forEach((child) => {
          if (child.selected) selectedItems.push(child);
        });
      } else if (item.selected) {
        // It's a flat item
        selectedItems.push(item);
      }
    });
    return selectedItems;
  }

  hiddenField () {
    const componentValues = this.selectedItems().map(item => item.id).join(',');

    return (
      <input
        type="hidden"
        id={this.props.hiddenFieldId}
        name={this.props.hiddenFieldName}
        value={componentValues} />
    );
  }

  togglePresentSelector = () => {
    if (this.props.onClose) { this.props.onClose(); }
    this.setState({ visible: !this.state.visible });
  }

  submit = () => {
    if (this.props.submitTo) {
      window.location = this.props.submitTo + this._getSelectedIds().join(',');
    } else {
      this.setState({ visible: !this.state.visible });
    }
  }

  _getSelectedIds () {
    return this.selectedItems().map(item => item.id);
  }

  _dispatchEvent () {
    // This crap is because we only need to do this on pages that
    // are listening with jQuery.
    if (typeof jQuery !== 'undefined') {
      $(document.body).trigger('items-selector-changed', { selectedIds: this._getSelectedIds() });
    }
  }

  render () {
    return (
      <div
        className={cx('grouped-items-selector', 'border-color', this.props.className)}
        style={{ display: (!this.state.visible) ? 'none' : null }}>

        <Header show={this.props.showHeader} />

        <ItemsCollection
          items={this.state.items}
          toggleItems={this.toggleItems}
          hasGroupedItems={this.state.hasGroupedItems}
          showTooltipDescriptions={this.props.showTooltipDescriptions}
        />

        {this.props.hiddenFieldName ? this.hiddenField() : null}

        <Footer
          show={this.props.showFooter}
          onSubmit={this.submit}
          onClose={this.togglePresentSelector}
          onClear={this.clearAllItems} />
      </div>
    );
  }
}

module.exports = ItemsSelector;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/items_selector/items_selector.jsx